import { Text } from "@fluentui/react-components";
import moment from "moment";
import { useEffect, useState } from "react";
import { SelectedResourceObject } from "../../APIService/UserBookingService";
import { CommonInfo } from "../../CommonData/Config";
import "./ResourceModel.css"
import { RecurringOption } from "./ResourceSpaceTypeModel";

type ConflictViewProps = {
  theme: string;
  resource: SelectedResourceObject;
  option: RecurringOption | null;
  startTime: Date;
  endTime: Date;
  onClose: () => void;
};

const ConflictView = ({
  theme,
  resource,
  option,
  startTime,
  endTime,
  onClose
}: ConflictViewProps) => {

  const [dates, setDates] = useState<Date[]>([]);

  useEffect(() => {
    console.log("ConflictViewProps resource: ", resource);
  }, []);

  useEffect(() => {

    if (!option) return;

    const recurringDates = generateRecurringDates(
      option.value,
      startTime,
      endTime
    );

    console.log("Recurring Dates:", recurringDates);
    setDates(recurringDates);

  }, [option, startTime]);

  const getResourceIcon = (spaceType: string) => {
    if (spaceType.toLocaleLowerCase().includes("desk")) {
      return "icon-desk"
    } else if (spaceType.toLocaleLowerCase().includes("room")) {
      return "icon-room"
    } else if (spaceType.toLocaleLowerCase().includes("parking")) {
      return "icon-parking"
    } else if (spaceType.toLocaleLowerCase().includes("space")) {
      return "icon-person"
    } else {
      return "icon-space"
    }
  }

  const getWeekOfMonth = (date: Date) => {
    return Math.ceil(date.getDate() / 7);
  };

  const getNthWeekdayOfMonth = (
    year: number,
    month: number,
    weekday: number,
    nth: number
  ) => {
    const firstDay = new Date(year, month, 1);
    const firstWeekday = firstDay.getDay();

    const offset = (weekday - firstWeekday + 7) % 7;
    const day = 1 + offset + (nth - 1) * 7;

    const result = new Date(year, month, day);

    if (result.getMonth() !== month) return null;

    return result;
  };

  const generateRecurringDates = (
    optionValue: number,
    startDate: Date,
    endDate: Date,
    maxOccurrences: number = 50
  ) => {
    const dates: Date[] = [];

    let current = new Date(startDate);

    const weekday = startDate.getDay();
    const dayOfMonth = startDate.getDate();
    const month = startDate.getMonth();
    const weekOfMonth = getWeekOfMonth(startDate);

    switch (optionValue) {

      case 0: // Never
        dates.push(startDate);
        break;

      case 1: // Every day
        while (current <= endDate && dates.length < maxOccurrences) {
          dates.push(new Date(current));
          current.setDate(current.getDate() + 1);
        }
        break;

      case 2: // Working day (Mon–Fri)
        while (current <= endDate && dates.length < maxOccurrences) {
          const day = current.getDay();
          if (day !== 0 && day !== 6) {
            dates.push(new Date(current));
          }
          current.setDate(current.getDate() + 1);
        }
        break;

      case 3: // Every weekday (e.g., every Tuesday)
        while (current <= endDate && dates.length < maxOccurrences) {
          if (current.getDay() === weekday) {
            dates.push(new Date(current));
            current.setDate(current.getDate() + 7);
          } else {
            current.setDate(current.getDate() + 1);
          }
        }
        break;

      case 4: // Every nth weekday (e.g., 2nd Tuesday)
        for (let i = 0; i < maxOccurrences; i++) {
          const year = startDate.getFullYear();
          const monthIndex = startDate.getMonth() + i;

          const date = getNthWeekdayOfMonth(
            year,
            monthIndex,
            weekday,
            weekOfMonth
          );

          if (!date || date > endDate) break;

          dates.push(date);
        }
        break;

      case 5: // Day X of every month
        for (let i = 0; i < maxOccurrences; i++) {
          const date = new Date(
            startDate.getFullYear(),
            startDate.getMonth() + i,
            dayOfMonth
          );

          if (date > endDate) break;

          if (date.getDate() === dayOfMonth) {
            dates.push(date);
          }
        }
        break;

      case 6: // Every X Month Day (yearly)
        for (let i = 0; i < maxOccurrences; i++) {
          const date = new Date(
            startDate.getFullYear() + i,
            month,
            dayOfMonth
          );

          if (date > endDate) break;

          dates.push(date);
        }
        break;
    }

    return dates;
  };

  const isDateUnavailable = (date: Date, ranges: any[]) => {
    return ranges.some((r) => {
      const start = new Date(r.StartDateTime);
      const end = new Date(r.EndDateTime);

      return date >= start && date <= end;
    });
  };

  return (
    <div style={{ width: "100%", height: "100%", borderRadius: 6, background: theme === "dark" ? "#1A1A1A" : "#FAFAFA", border: theme === "dark" ? "1px solid #525252" : "1px solid #EAEFF5", }}>
      <div style={{ width: "100%", height: "64px", backgroundColor: theme === "dark" ? "rgba(238, 238, 238, 0.2)" : "#eeeeee5c", borderBottom: theme === "dark" ? "1px solid #525252" : "1px solid #EAEFF5", display: "flex", flexDirection: "row", alignItems: "center", padding: "12px 10px" }}>
        <span className={`${getResourceIcon(resource.resource.SpaceType)}`} style={{ fontSize: 38 }} />
        <div className="bookingDetailContainer" style={{ height: "40px" }}>
          <Text style={{ height: 24, fontSize: 14, fontStyle: "normal", fontWeight: 400, paddingRight: "10px", paddingLeft: "10px" }}>{resource.resource.ResName}</Text>
          <Text style={{ height: 16, fontSize: 12, fontStyle: "normal", fontWeight: 300, paddingRight: "10px", paddingLeft: "10px" }}>{`${resource.resource.Location.Building} | ${resource.resource.Location.Floor} | ${resource.resource.Location.Zone}`}</Text>
        </div>
        <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/checkoutlight.svg' : '/checkout.svg'}`} width={26} height={26} onClick={() => onClose()} style={{ backgroundColor: "#EEEEEE33", borderRadius: "6px", border: theme === "dark" ? "1px solid #525252" : "1px solid #EAEFF5" }} />
      </div>
      <div style={{ gap: "10px", height: "50%", display: "flex", flexDirection: "column", overflowY: "auto" }}>
        {dates.map((date, index) => {

          const unavailable = isDateUnavailable(date, resource.unavailableDateTime ?? []);

          return (
            <div key={index} style={{ padding: "2px", gap: "1px", display: "flex", flexDirection: "column" }}>

              <Text style={{ height: 24, fontSize: 13, fontWeight: 400, padding: "0 10px" }}>
                {moment(date).format("dddd DD MMMM YYYY")}
              </Text>

              <Text style={{ height: 16, fontSize: 11, fontWeight: 300, padding: "0 10px" }}>
                {resource.resource.ResName}
              </Text>

              <div style={{ display: "flex", alignItems: "center", height: 16, padding: "2px 10px", marginTop: "5px" }}>

                <img
                  src={`${CommonInfo.folderName}/${unavailable ? "clockRed.svg" : "clockGreen.svg"}`}
                  style={{ width: "12px", height: "12px" }}
                />

                <Text
                  style={{
                    marginLeft: "2px",
                    fontSize: 12,
                    fontWeight: 400,
                    color: unavailable ? "#E53935" : "#29C365"
                  }}
                >
                  {unavailable ? "Unavailable" : "Available"}
                </Text>

              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ConflictView;